import React, { Component } from 'react';
import {Map, Marker, GoogleApiWrapper} from 'google-maps-react';
import { Link } from 'react-router-dom';
import './Dojo.css';
import { DojoRepository } from '../data/DojoRepository';

class SaintJerome extends Component {
  render() {
    return (
        <div class="container page-content">
            <div id="dojoHeader">
                <img id="ShotokanLogo" alt="Logo du karaté Shotokan" src="/images/logos/Shotokan.png" />
            </div>
            <article id="dojoContent">
                <section id="dojoDescription">
                    <h1>{DojoRepository.ST_JEROME.name}</h1>
                    <p>Le dojo Ganbaru des Laurentides a été créé en janvier 2015. Le terme japonais (Ganbaru) signifie : ténacité, persévérance, courage, motivation, aller au-delà de ses limites. Nous souhaitons transmettre ces valeurs à nos membres par le biais d’un enseignement traditionnel et contemporain.</p>
                </section> 
                <p>&nbsp;</p>
            
                <section id="dojoTeam"> 
                    <h1>L'équipe</h1>
                    <p>Sensei Jean-Pierre Schulz (3e dan) et sensei Michel Dufour (4e dan), amis et partenaires d'entraînement de longue date, offrent un enseignement respectueux de la philosophie du Karaté Shotokan, adapté à tous et prodigué en fonction de leur personnalité respective.</p>
                    <p>&nbsp;</p>
                    <p>
                        <strong>Instructeurs</strong><br />
                        Michel Dufour - 4e Dan<br />
                        Jean-Pierre Schulz - 3e Dan<br />
                    </p>
                </section> 
                <p>&nbsp;</p>
            
                <section id="dojoSchedule"> 
                    <h1>Horaire</h1>
                    <p><strong>Lundi</strong></p>
                    <p>
                        18:00 - Débutants à vertes<br />
                        19:15 - Bleues à noires
                    </p>
                    <p><strong>Jeudi</strong></p>
                    <p>
                        18:00 - Débutants à vertes<br />
                        19:15 - Bleues à noires
                    </p>
                </section>
                <p>&nbsp;</p>
            
                <section id="dojoPrices"> 
                    <h1>Tarifs</h1>
                    <table class="price-table" border="1" cellSpacing="1" cellPadding="1">
                        <tbody>
                            <tr>
                                <td colSpan="2">Tarifs pour 15 semaines</td>
                            </tr>
                            <tr>
                                <td class="description-column">Enfants</td>
                                <td class="price-column">125$</td>
                            </tr>
                            <tr>
                                <td class="description-column">Adultes</td>
                                <td class="price-column">160$</td>
                            </tr>
                        </tbody>
                    </table>
                    <p>&nbsp;</p>
                    <table class="price-table" border="1" cellSpacing="1" cellPadding="1">
                        <tbody>
                            <tr>
                                <td colSpan="2">Tarifs à la carte</td>
                            </tr>
                            <tr>
                                <td class="description-column">Enfants</td>
                                <td class="price-column">7$</td>
                            </tr>
                            <tr>
                                <td class="description-column">Adultes</td>
                                <td class="price-column">10$</td>
                            </tr>
                        </tbody>
                    </table>
                    <p>&nbsp;</p>
                    <p><em>Notes: Ajouter la cotisation annuelle à Québec ISKF de 45 $ (adulte) et 40 $ (enfants).</em></p>
                </section> 
                <p>&nbsp;</p>
            
                <section id="dojoContacts"> 
                    <h1>Pour nous joindre</h1>
                    <p>
                        <strong>Instructeurs</strong><br /><br />
                        Michel Dufour<br />
                        (450) 543-0172<br />
                        <span class="link-like">michel.dufour@quebeciskf.com</span><br /><br />
                        Jean-Pierre Schulz<br />
                        (450) 660-4330<br />
                        <span class="link-like">jpierre.schulz@quebeciskf.com</span>
                    </p>
                    <p>&nbsp;</p>
                    <p>
                        <strong>Dojo Ganbaru des Laurentides</strong><br />
                        École Prévost<br />
                        85, rue Lauzon<br />
                        St-Jérôme, QC<br />
                        J7Y 1V8<br />
                        <a href={DojoRepository.ST_JEROME.links.googleMaps} target="_blank" rel="noopener noreferrer" title="Dojo Quebec Shitokan - emplacement">Google Maps</a>
                    </p>
                </section> 
                <p>&nbsp;</p>
                
                <section id="dojo-map">
                    <Map
                        google={this.props.google}
                        initialCenter={DojoRepository.ST_JEROME.geo}>
                        <Marker position={DojoRepository.ST_JEROME.geo} />
                    </Map>
                </section>
            </article>
            <Link class="returnToDojoRepository" to="/dojo">Retour au repertoire des Dojos</Link>
        </div>
    );
  }
}

export default GoogleApiWrapper({
    apiKey: ("AIzaSyCqdJMLfuasXIr2gfxOzJyfP1gXVQt5-H8")
})(SaintJerome)



// WEBPACK FOOTER //
// ./src/pages/dojo/SaintJerome.js